import React from 'react';
import ModalLeadComponent from '../Component/ModalLeadComponent';
import {
  deleteLeadAPI,
  getLeadsDocumentAPI,
} from '../../../Services/leads.api';
import { toast } from 'react-toastify';
import { toastr } from 'react-redux-toastr';
import { IResultLeadsListDAO } from '../DAO/leads.dao';
import { useMutation, useQuery } from '@tanstack/react-query';

interface IProps {
  handleCancel: () => void;
  selectedData: IResultLeadsListDAO;
}

export default function ModalLeadContainer(props: IProps) {
  const { handleCancel, selectedData } = props;

  const { data: imageList, isFetching } = useQuery(
    ['getLeadList', selectedData.leadDocuments],
    getLeadsDocumentAPI,
    {
      refetchOnWindowFocus: false,
    }
  );

  const deleteLead = useMutation(deleteLeadAPI, {
    onError: (error: any) => {
      const errorData = error?.response?.data;
      toast.error(<span className="capitalFirst">{errorData.Message}</span>);
    },
    onSuccess: () => {
      toast.success('Lead berhasil dihapus', {
        className: 'toastSuccessBackground',
      });
      handleCancel();
    },
  });

  const handleDelete = () => {
    const toastrConfirmOptions = {
      okText: 'Delete',
      cancelText: 'Batalkan',
      onOk: () => deleteLead.mutate(selectedData.id),
      id: 'toastRConfirm',
    };
    toastr.confirm(
      `Delete Channel "${selectedData.name}"`,
      toastrConfirmOptions
    );
  };

  return (
    <ModalLeadComponent
      data={selectedData}
      handleCancel={handleCancel}
      handleDelete={handleDelete}
      imageList={imageList}
      isLoading={isFetching}
    />
  );
}
